import { render } from "./CustomerAppointments.vue?vue&type=template&id=5516ccb6"
import script from "./CustomerAppointments.vue?vue&type=script&lang=js"
export * from "./CustomerAppointments.vue?vue&type=script&lang=js"

import "./CustomerAppointments.vue?vue&type=style&index=0&id=5516ccb6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__